/* eslint-disable */
const getters = {
  getTax(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
